import React, { useEffect } from "react";
import "./comiteetica.css";
import { Link } from "react-router-dom";
import { etica_item } from "../../json/comiteEtica";
import { comite_item } from "../../json/comiteEtica";
import { mecanismos_item } from "../../json/comiteEtica";

const ComiteEtica = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  
  const linkStyle = {
    textDecoration: 'none'
  };

  return (
    <div className="container comiteetica-container">
      <div className="row">
        <div className="col_12">
          <div className="comiteetica_title">
            <h1>Comité de Ética y Prevención de Conflictos de Interés</h1>
          </div>
        </div>
      </div>

      <hr className="hr-gob" />
      <img className="imgHonradez" src=" https://transparenciadocs.hidalgo.gob.mx/dependencias/agricultura/dir1/SEDAGROH/DocsPagweb/Etica/HONRADEZ.jpg" />
      <img
        className="imgImparcialidad"
        src="https://transparenciadocs.hidalgo.gob.mx/dependencias/agricultura/dir1/SEDAGROH/DocsPagweb/Etica/IMPARCIALIDAD.jpg"
      />
      <img className="imgLealtad" src="https://transparenciadocs.hidalgo.gob.mx/dependencias/agricultura/dir1/SEDAGROH/DocsPagweb/Etica/LEALTAD.jpg" />
      <img className="imgLegalidad" src="https://transparenciadocs.hidalgo.gob.mx/dependencias/agricultura/dir1/SEDAGROH/DocsPagweb/Etica/LEGALIDAD.jpg" />
      <div class="row row-gob row-body">
								{/* <div class="row-content">
      <h1 className="comiteetica_title">
        Código de Ética de la Administración Pública del Estado de Hidalgo
      </h1>

      <hr className="hr-gob" />
      <iframe
        src="https://transparenciadocs.hidalgo.gob.mx/dependencias/agricultura/dir1/SEDAGROH/DocsPagweb/Etica/CodigoEticaAdministracionPublica.pdf"
        height="1000"
        width="1110"
      />
      </div> */}
     </div>  
      <hr class="blue small-margin"></hr>
      <div class="row row-gob row-body">
								<div class="row-content">
      <header class="col-12">
										<h3 class="h3-apps">Comité de Ética y Prevención de Conflictos de Interés</h3>
										<hr class="blue small-margin"></hr>
									</header>
                  <div className="row">
        {comite_item.map((item, index) => (
          <>
            <div key={index} className="col-md-4">
              <Link  style={linkStyle} to={item.etica_item_url}>
                <div className="card">
                  <div className="card-body">
                    <div className="sec_transparencia">
                      <h5>{item.etica_item_nombre}</h5>
                    </div>
                  </div>
                </div>
              </Link>
            </div>
          </>
        ))}
      </div>
      </div>
      </div>
      <hr class="blue small-margin"></hr>
      <div class="row row-gob row-body">
								<div class="row-content">
      <header class="col-12">
										<h3 class="h3-apps">Sesiones Ordinarias del Comité de Ética</h3>
										<hr class="blue small-margin"></hr>
									</header>
                  <div className="row">
        {etica_item.map((item, index) => (
          <>
            <div key={index} className="col-md-4">
              <Link  style={linkStyle} to={item.etica_item_url}>
                <div className="card">
                  <div className="card-body">
                    <div className="sec_transparencia">
                      <h5>{item.etica_item_nombre}</h5>
                    </div>
                  </div>
                </div>
              </Link>
            </div>
          </>
        ))}
      </div>
      </div>
      </div>
      <hr class="blue small-margin"></hr>
      <div class="row row-gob row-body">
								<div class="row-content">
      <header class="col-12">
										<h3 class="h3-apps">MECANISMOS CEPCI</h3>
										<hr class="blue small-margin"></hr>
									</header>
                  <div className="row">
        {mecanismos_item.map((item, index) => (
          <>
            <div key={index} className="col-md-4">
              <Link  style={linkStyle} to={item.mecanismos_item_url}>
                <div className="card">
                  <div className="card-body">
                    <div className="sec_transparencia">
                      <h5>{item.mecanismos_item_nombre}</h5>
                    </div>
                  </div>
                </div>
              </Link>
            </div>
          </>
        ))}
      </div>
      </div>
      </div>
      
    </div>
  );
};

export default ComiteEtica;
